import { useEffect } from "react";
import { useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";

/** Aplica colores del CMS a las variables CSS globales (--gold, --text, etc.) */
export default function ThemeApplicator() {
  const { data: theme } = useContentObject("theme.branding", contentFallback("theme.branding"));

  useEffect(() => {
    const root = document.documentElement;
    const apply = (name, value) => {
      if (value) root.style.setProperty(name, value);
    };

    apply("--gold", theme?.color_gold);
    apply("--gold-light", theme?.color_gold_light);
    apply("--gold-dark", theme?.color_gold_dark);
    apply("--text", theme?.color_text);
    apply("--text-2", theme?.color_muted);
    apply("--bg", theme?.color_bg);

    if (theme?.color_gold) {
      const hex = theme.color_gold.replace("#", "");
      if (hex.length === 6) {
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        apply("--gold-rgb", `${r}, ${g}, ${b}`);
      }
    }

    const favicon = document.querySelector("link[rel='icon']");
    if (theme?.favicon_url && favicon) favicon.href = theme.favicon_url;
  }, [theme]);

  return null;
}
